import { render, staticRenderFns } from "./payments-stats.vue?vue&type=template&id=33a0a0fd"
import script from "./payments-stats.vue?vue&type=script&lang=js"
export * from "./payments-stats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports